<template>
<div class="tk035" v-cloak>
    <breadcrumb :navListCustom="[{title:'マイページ', routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}, {title: $t('tk001.labels.title'), routerName: '', param: {}}]"></breadcrumb>
    <div>
        <div class="itemTitle">
            <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
        </div>

        <!--エラーメッセージ表示 -->
        <div class="errMessage">
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'tk035'"/>
        </div>

        <div class="pageFeed">
            <h3 class="subTitle">{{$t('tk001.labels.title')}}</h3>
            <p class="teikiExplain1">{{$t('tk001.labels.titleSub1')}}</p>
            <p class="teikiExplain2">{{$t('tk001.labels.titleSub2')}}</p>
            <p class="teikiExplain3">{{$t('tk001.labels.titleSub3')}}</p>
            <!-- タイトル部分 -->
            <div class="payChangeBtn" v-if="isChangeKessai">
                <!-- 支払い方法変更 定期毎に支払い変更オプションの場合は表示しない-->
                <input v-if="tk001Init.teikiPayChangeFlg == 0" class="btnSubmit" type="submit" @click="changeKessai()" :value="$t('tk001.buttons.shiharaiChange')">
                <br>
                <table class="tk010-play-point-tbl" v-if="tk001Init.teikiPointRiyouSetting == 1">
                    <tr>
                        <th style="letter-spacing: normal;">{{$t('tk001.labels.teikiPointRiyou')}}</th>
                        <label id="pointAutoRiyouNum_lbl" style="display: none"   >{{$t('tk001.labels.teikiPointRiyouCkE')}}</label>
                        <td>
                            <input type="radio" name="point_kbn" :value="'1'" :id="'_point_kbn_0'" :checked="'1' == reqModel.pointAutoJuutouFlg ? 'checked':''" v-model="reqModel.pointAutoJuutouFlg" @click="selectPoint('0')"/>
                            <label :for="'_point_kbn_0'" style="width: auto;vertical-align:baseline;">{{$t("sh050.labels.allPoint")}}</label>
                            <input type="radio" name="point_kbn" :value="'2'" :id="'_point_kbn_1'" :checked="'2' == reqModel.pointAutoJuutouFlg ? 'checked':''" v-model="reqModel.pointAutoJuutouFlg" @click="selectPoint('1')"/>
                            <label :for="'_point_kbn_1'" style="width: auto;vertical-align:baseline;">{{$t("sh050.labels.partPoint")}}</label>
                            <input-number type="text" :maxlength="7" :style="'width:100px; background-color:'+background" :disabled="disable" v-model="reqModel.pointAutoRiyouNum" name="pointAutoRiyouNum" id="pointAutoRiyouNum"/>{{$t("sh050.labels.pt")}}
                            <input type="radio" name="point_kbn" :value="'0'" :id="'_point_kbn_2'" :checked="'0' == reqModel.pointAutoJuutouFlg ? 'checked':''" v-model="reqModel.pointAutoJuutouFlg" @click="selectPoint('2')"/>
                            <label :for="'_point_kbn_2'" style="width: auto;vertical-align:baseline;">{{$t("sh050.labels.notPoint")}}</label>
                        </td>
                        <td class="text-center">
                            <button type="button" class="btnSubmit" @click="savePointSetting()">{{$t('tk001.buttons.savePointSetteing')}}</button>
                        </td>
                    </tr>
                </table>
            </div>
            <!--定期商品一覧 -->
            <template>
                <div class="teikiList" v-for="(item, itemIndex) in tk001Init.teikiList" :key="itemIndex">
                    <div class="teikiData">
                        <!--定期No -->
                        <div class="teikiNo">
                            {{$t('tk001.labels.teikiNo')}}{{item.TEIKI_CD_TYPICAL}}
                        </div>
                        <!--出荷予定日 -->
                        <div v-if="item.SHIP_KAN_FLG == '0' && item.DISP_FLG == '0' && item.CANCEL_FLG == '0'" class="teikiDate">
                            <a v-if="item.SYUKKA_YOTEI_YMD != null" @click="gotoHistoryPage(item.ORDER_NO,item.ORDER_CD_TYPICAL)">
                                {{item.SYUKKA_YOTEI_YMD}}{{$t('tk001.labels.shipprepareingTitle')}}
                            </a>
                        </div>
                        <!--次回発送予定日 -->
                        <div class="teikiNextDate">
                            {{$t('tk001.labels.jikaiTitle')}}{{item.NEXT_SYUKKA_YOTEI_YMD}}{{$t('tk001.labels.sendYoteiDay')}}
                        </div>
                        <!--申込日 -->
                        <div class="teikiOrderYmd">
                                <div class="label">{{$t('tk001.labels.moshikomiDay')}}</div>
                                <div class="data">{{item.FIRST_ORDER_YMD}}</div>
                        </div>
                        <!-- 間隔 -->
                        <div class="teikiKankaku">
                            <div class="label">{{$t('tk001.labels.teikiKankaku')}}</div>
                            <div class="data">{{item.TEIKI_KANKAKU}}{{$t('tk001.labels.teikiKankakuKbn['+item.TEIKI_KANKAKU_KBN+']')}}</div>
                        </div>
                        <!--前回発送日 -->
                        <div class="sendDay">
                            <div class="label">{{$t('tk001.labels.maeSendDay')}}</div>
                            <div class="data">{{strNvl(item.LAST_SYUKKA_YOTEI_YMD)}}</div>
                        </div>
                        <!--お支払い方法 -->
                        <div class="payInfo">
                            <div class="label">{{$t('tk001.labels.shiharaiHou')}}</div>
                            <div class="data">{{item.KESSAI_NM}}</div>
                        </div>
                        <template v-for="(detailsItem, itemDetailsIndex) in tk001Init.teikiDetailsList" >
                            <div class="teikiItemInfo" v-if="item.TEIKI_CD_TYPICAL == detailsItem.TEIKI_CD_TYPICAL" :key="itemDetailsIndex">
                                <img :src="detailsItem.IMG_URL1" class="teikiImage" @error="getErrImage">
                                <!--商品名 -->
                                <div class="teikiNm">
                                    {{detailsItem.WEB_ITEM_NM}}
                                </div>
                                <!--販売単価 -->
                                <div class="saleTnk">
                                    <div class="label">{{$t('tk001.labels.saleTnk')}}</div>
                                    <div class="data">{{ detailsItem.TNK_DSP_KBN == '1'? formatPrice(detailsItem.SALE_ZEI_K_TNK) : formatPrice(detailsItem.SALE_TNK)}}{{$t('common.labels.jpYen')}}</div>
                                </div>
                            </div>
                        </template>
                        <div class="teikiBtnList">
                            <!--詳細を表示-->
                            <input type="button" class="btnSubmit" @click="gotoDetailPage(item.TEIKI_NO,item.TEIKI_CD_TYPICAL)" :value="$t('tk001.buttons.detaiShow')">
                        </div>
                    </div>
                </div>
            </template>
            <!--戻るボタン-->
            <div id="btn_roll3" v-if="tk001Init.backButtonFlg == 1">
                <a class="btnCancel" @click="backUrl()">{{$t('common.buttons.return')}}</a>
            </div>
        </div>
    </div>
    <TK013 v-if="showTk013Flg" :data="dataTk013" @data-selected="setDataTk013">></TK013>
</div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import moment from 'moment';
import axios from "assets/js/request";
import DatePickers from 'components/DatePicker';
import InputCheck from 'components/InputCheck';
import InputNumber from 'components/InputNumber';
import Message from 'components/MessageEcSite';
import PageFeed from '../commonParts/PageFeed';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import Loading from 'vue-loading-overlay';
import toastr from 'toastr/toastr.js';
import "toastr/build/toastr.min.css";
import TK013 from '../popup/TK013MemberTeikiTdkList.vue';

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "3000",
};

export default {
    /* 
    * Name of component
    */
    name: "TK035TeikiIkkatuListParts",
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /*
    * Declare components
    */
    components:{
            TK013,
            DatePickers,
            InputCheck,
            InputNumber,
            Message,
            PageFeed,
            Loading,
            toastr,
            Breadcrumb
        },
    data() {
        return {
            isDisplay: false,
            rowIndex: null,
            isPagingDisplay:true,
            isLoading: false,
            siteFlg : null,
            reqModel:{
                kokyakuBirth: null,
                yearMonth: null,
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 15,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1
            },
            tk001Init: {},
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 1,
                toRecord: 10,
                pageSize: 10,
                pageNo: 1
            },
            dispPageSizeList:[
                {value: 5,text: "5行"},
                {value: 15,text: "15行"},
                {value: 30,text: "30行"},
                {value: 45,text: "45行"},
                {value: 50,text: "50行"},
                {value: 100,text: "100行"}
            ],
            SiteConstants: SiteConstants,
            iSearch:false,
            isChangeKessai: false,
            // for validate
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            jptuisekiLink: null,
            site: "",
            showTk013Flg:false,
            dataTk013:{},
            todayStr: moment().add(1,'d').format('YYYY/MM/DD')
        }
    },
    mounted() {
        // Call API doInit
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            if(_this.ptInitData.status == 'NG'){
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
            }else {
                _this.tk001Init = _this.ptInitData;
                _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModel);
                if (_this.tk001Init.teikiList.length > 0) {
                    _this.isChangeKessai = true;
                }
            }
        }else{
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK035 + _this.$UrlConstants.DO_INIT, _this.reqModel).then(function(response) {
                if(response.data.status == 'NG'){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                }else {
                    _this.tk001Init = response.data;
                    _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                    if (_this.tk001Init.teikiList.length > 0) {
                        _this.isChangeKessai = true;
                    }
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        if (_this.reqModel.pointAutoJuutouFlg == '1') {
            _this.selectPoint('0');
        } else if (_this.reqModel.pointAutoJuutouFlg == '2') {
            _this.selectPoint('1');
        } else {
            _this.selectPoint('2');
        }
    },

    methods: {
        changeTdk: function(teikiCd,tdkYmd,nextSyukkaYmd){
            var _this = this;
            _this.showTk013Flg = true;
            _this.reqModel.teikiNo = teikiCd;
            _this.reqModel.tdkYmd = common.stringNvl(tdkYmd,nextSyukkaYmd);
            _this.dataTk013.teikiNo = teikiCd;
            _this.dataTk013.tdkYmd = common.stringNvl(tdkYmd,nextSyukkaYmd);
        },
        savePointSetting: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK035 + _this.$UrlConstants.DO_NEXT, _this.reqModel).then(function(response) {
                if(response != null && response != undefined){
                    toastr.success(_this.$i18n.t("tk001.messages.messg1"));
                }
                _this.$emit("event-loading", !true);
            })
            .catch(function(error) {
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, "tk001");
                            console.log("resultValid===",resultValid);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                _this.$emit("event-loading", !true);
            });
        },
        setDataTk013: function(responseData){
            if(!responseData) {
                this.showTk013Flg = false;
                this.$router.go(0);
                return;
            }
        },
        //Methods for pageFeed
        gotoDetailPage: function(teikiNo,teikiCdTypical) {
            var tranferdata={};
            //var reqModel ={};
            tranferdata ={pageNo:89, 
                          teiki_no : teikiNo,
                          teiki_cd_typical : teikiCdTypical,
                          //dataRequest : reqModel
                          };
            this.$router.push({name: SiteConstants.PG010MAIN, query: tranferdata});
        },
        //Methods for pageFeed
        gotoHistoryPage: function(orderNo,orderCdTypical) {
            var tranferdata={};
            //var reqModel ={};
            tranferdata ={pageNo:10, 
                          orderNo : orderNo,
                          orderCdTypical : orderCdTypical,
                          fBaFlg : 0,
                          returnPage:'TK035'
                         };
            this.$router.push({name: SiteConstants.PG010MAIN, query: tranferdata});
        },
        // スキップ処理
        changeToSkip: function(teikiNo) {
            var _this = this;
            var rs;
            _this.reqModel.teikiNo = teikiNo;
            _this.reqModel.updateFlg = '0';
            rs = confirm(_this.$i18n.t('tk001.labels.confirmMess'));
            if(rs){
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK035 + _this.$UrlConstants.DO_UPDATE, _this.reqModel).then(function(response) {
                    if(response != null && response != undefined){
                        _this.tk001Init = response.data;
                        //_this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                    }
                })
                .catch(function(error) {
                    common.errorAPI(error);
                });
            }else{
                return false;
            }
        },
        changeKessai: function() {
            var _this = this;
            var teikiFlg = '1';
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 82}, params: {teikiFlg: teikiFlg,backPageNo: 88}} );
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        strNvl(data) {
            return  common.stringNvl(data,'-');
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function() {
            var _this = this;
            // マイメニュー画面へ遷移
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 81}});
        },
        /*
        * ポイント利用区分選択
        */ 
        selectPoint: function (value) {
            var _this = this;
            switch (value) {
                // すべて使う
                case "0":
                    _this.reqModel.pointAutoRiyouNum = null;
                    _this.disable = true;
                    _this.background = "#C0C0C0;";
                    break;
                // 一部使う
                case "1":
                    _this.disable = false;
                    _this.background = "";
                    break;
                // 使わない
                case "2":
                    _this.reqModel.pointAutoRiyouNum = null;
                    _this.disable = true;
                    _this.background = "#C0C0C0;";
                    break;
            }
        },
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.reqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.reqModel.pageSize = this.queryData.ptPageSize;
            }
        }
        //Get param from router when contructor this.  
        var data = _this.$route.params;
        if (data.requestBack!=null){
            _this.reqModel = Object.assign({}, _this.reqModel, data.requestBack);
            _this.iSearch=true;
        }
    }
}
</script>
